<template>
  <section class="lm-container" :style="{ width: `${ width }px` }"><slot></slot></section>
</template>

<style scoped lang="scss">
.lm-container {
  margin-right: auto;
  margin-left: auto;
}
</style>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 1500
    }
  }
}
</script>
